import { CustomMask } from './types';

export const Masks: CustomMask[] = [
  { mask: '+93 00-000-0000', startsWith: '93', country: 'AF' },
  { mask: '+355 (000)000-000', startsWith: '355', country: 'AL' },
  { mask: '+213 00-000-0000', startsWith: '213', country: 'DZ' },
  { mask: '+376 000-000', startsWith: '376', country: 'AD' },
  { mask: '+244 (000)000-000', startsWith: '244', country: 'AO' },
  { mask: '+672 100-000', startsWith: '672', country: 'AQ' },
  { mask: '+54 (000)000-0000', startsWith: '54', country: 'AR' },
  { mask: '+374 00-000-000', startsWith: '374', country: 'AM' },
  { mask: '+297 000-0000', startsWith: '297', country: 'AW' },
  { mask: '+247 0000', startsWith: '247', country: 'AC' },
  { mask: '+61 0-0000-0000', startsWith: '61', country: 'AU' },
  { mask: '+43 (000)000-0000', startsWith: '43', country: 'AT' },
  { mask: '+994 00-000-00-00', startsWith: '994', country: 'AZ' },
  { mask: '+973 0000-0000', startsWith: '973', country: 'BH' },
  { mask: '+88\\0 0000 000000', startsWith: '880', country: 'BD' },
  { mask: '+375 (00)000-00-00', startsWith: '375', country: 'BY' },
  { mask: '+32 (000)000-000', startsWith: '32', country: 'BE' },
  { mask: '+5\\01 000-0000', startsWith: '501', country: 'BZ' },
  { mask: '+229 00-00-0000', startsWith: '229', country: 'BJ' },
  { mask: '+975 17-000-000', startsWith: '975', country: 'BT' },
  { mask: '+591 0-000-0000', startsWith: '591', country: 'BO' },
  { mask: '+387 00-0000', startsWith: '387', country: 'BA' },
  { mask: '+267 00-000-000', startsWith: '267', country: 'BW' },
  { mask: '+55 (00)0000-0000', startsWith: '55', country: 'BR' },
  { mask: '+246 000-0000', startsWith: '246', country: 'IO' },
  { mask: '+673 000-0000', startsWith: '673', country: 'BN' },
  { mask: '+359 (000)000-000', startsWith: '359', country: 'BG' },
  { mask: '+226 00-00-0000', startsWith: '226', country: 'BF' },
  { mask: '+257 00-00-0000', startsWith: '257', country: 'BI' },
  { mask: '+855 00 000 0000', startsWith: '855', country: 'KH' },
  { mask: '+237 0000-0000', startsWith: '237', country: 'CM' },
  { mask: '+1 (000)000-0000', startsWith: '1', country: 'CA' },
  { mask: '+238 (000)00-00', startsWith: '238', country: 'CV' },
  { mask: '+236 00-00-0000', startsWith: '236', country: 'CF' },
  { mask: '+235 00-00-00-00', startsWith: '235', country: 'TD' },
  { mask: '+56 0-0000-0000', startsWith: '56', country: 'CL' },
  { mask: '+86 (000)0000-000', startsWith: '86', country: 'CN' },
  { mask: '+57 (000)000-0000', startsWith: '57', country: 'CO' },
  { mask: '+269 00-00000', startsWith: '269', country: 'KM' },
  { mask: '+242 00-00000', startsWith: '242', country: 'CG' },
  { mask: '+682 00-000', startsWith: '682', country: 'CK' },
  { mask: '+5\\06 0000-0000', startsWith: '506', country: 'CR' },
  { mask: '+385 00-000-000', startsWith: '385', country: 'HR' },
  { mask: '+53 0-000-0000', startsWith: '53', country: 'CU' },
  { mask: '+357 00-000-000', startsWith: '357', country: 'CY' },
  { mask: '+42\\0 (000) 000-000', startsWith: '420', country: 'CZ' },
  { mask: '+243 (000)000-000', startsWith: '243', country: 'CD' },
  { mask: '+45 00-00-00-00', startsWith: '45', country: 'DK' },
  { mask: '+253 00-00-00-00', startsWith: '253', country: 'DJ' },
  { mask: '+593 0-000-0000', startsWith: '593', country: 'EC' },
  { mask: '+2\\0 (000)000-0000', startsWith: '20', country: 'EG' },
  { mask: '+5\\03 00-00-0000', startsWith: '503', country: 'SV' },
  { mask: '+24\\0 00-000-0000', startsWith: '240', country: 'GQ' },
  { mask: '+291 0-000-000', startsWith: '291', country: 'ER' },
  { mask: '+372 000-0000', startsWith: '372', country: 'EE' },
  { mask: '+268 00-00-0000', startsWith: '268', country: 'SZ' },
  { mask: '+251 00-000-0000', startsWith: '251', country: 'ET' },
  { mask: '+5\\0\\0 00000', startsWith: '500', country: 'FK' },
  { mask: '+298 000-000', startsWith: '298', country: 'FO' },
  { mask: '+679 00-00000', startsWith: '679', country: 'FJ' },
  { mask: '+358 00 000 00 00', startsWith: '358', country: 'FI' },
  { mask: '+33 (000)000-000', startsWith: '33', country: 'FR' },
  { mask: '+594 00000-0000', startsWith: '594', country: 'GF' },
  { mask: '+689 00-00-00', startsWith: '689', country: 'PF' },
  { mask: '+241 0-00-00-00', startsWith: '241', country: 'GA' },
  { mask: '+22\\0 (000)00-00', startsWith: '220', country: 'GM' },
  { mask: '+995 (000)000-000', startsWith: '995', country: 'GE' },
  { mask: '+49 000-0000000000', startsWith: '49', country: 'DE' },
  { mask: '+233 (000)000-000', startsWith: '233', country: 'GH' },
  { mask: '+35\\0 000-00000', startsWith: '350', country: 'GI' },
  { mask: '+3\\0 (000)000-0000', startsWith: '30', country: 'GR' },
  { mask: '+299 00-00-00', startsWith: '299', country: 'GL' },
  { mask: '+59\\0 (000)000-000', startsWith: '590', country: 'GP' },
  { mask: '+5\\02 0-000-0000', startsWith: '502', country: 'GT' },
  { mask: '+224 00-000-000', startsWith: '224', country: 'GN' },
  { mask: '+245 0-000000', startsWith: '245', country: 'GW' },
  { mask: '+592 000-0000', startsWith: '592', country: 'GY' },
  { mask: '+5\\09 00-00-0000', startsWith: '509', country: 'HT' },
  { mask: '+39 06 69800000', startsWith: '39', country: 'VA' },
  { mask: '+5\\04 0000-0000', startsWith: '504', country: 'HN' },
  { mask: '+852 0000 0000', startsWith: '852', country: 'HK' },
  { mask: '+36 00 000-0000', startsWith: '36', country: 'HU' },
  { mask: '+354 000-0000', startsWith: '354', country: 'IS' },
  { mask: '+91 (0000)000-000', startsWith: '91', country: 'IN' },
  { mask: '+62 00-000-00', startsWith: '62', country: 'ID' },
  { mask: '+98 (000)000-0000', startsWith: '98', country: 'IR' },
  { mask: '+924 (000)000-0000', startsWith: '924', country: 'IQ' },
  { mask: '+353 (000)000-000', startsWith: '353', country: 'IE' },
  { mask: '+972 0-000-0000', startsWith: '972', country: 'IL' },
  { mask: '+39 (000)0000-000', startsWith: '39', country: 'IT' },
  { mask: '+225 00-000-000', startsWith: '225', country: 'CI' },
  { mask: '+81 (000)000-000', startsWith: '81', country: 'JP' },
  { mask: '+962 0-0000-0000', startsWith: '962', country: 'JO' },
  { mask: '+77 (600)000-00-00', startsWith: '77', country: 'KZ' },
  { mask: '+254 000-000000', startsWith: '254', country: 'KE' },
  { mask: '+686 00-000', startsWith: '686', country: 'KI' },
  { mask: '+85\\0 000-000', startsWith: '850', country: 'KP' },
  { mask: '+82 00-000-0000', startsWith: '82', country: 'KR' },
  { mask: '+383 00-000-000', startsWith: '383', country: 'XK' },
  { mask: '+965 0000-0000', startsWith: '965', country: 'KW' },
  { mask: '+996 (000)000-000', startsWith: '996', country: 'KG' },
  { mask: '+856 00-00000000', startsWith: '856', country: 'LA' },
  { mask: '+371 00-000-000', startsWith: '371', country: 'LV' },
  { mask: '+961 0-000-000', startsWith: '961', country: 'LB' },
  { mask: '+266 0-000-0000', startsWith: '266', country: 'LS' },
  { mask: '+231 00-000-000', startsWith: '231', country: 'LR' },
  { mask: '+218 00-000-000', startsWith: '218', country: 'LY' },
  { mask: '+423 (000)000-0000', startsWith: '423', country: 'LI' },
  { mask: '+37\\0 (000)00-000', startsWith: '370', country: 'LT' },
  { mask: '+352 (000)000-000', startsWith: '352', country: 'LU' },
  { mask: '+853 0000-0000', startsWith: '853', country: 'MO' },
  { mask: '+261 00-00-00000', startsWith: '261', country: 'MG' },
  { mask: '+265 1-000-000', startsWith: '265', country: 'MW' },
  { mask: '+6\\0 00-0000-0000', startsWith: '60', country: 'MY' },
  { mask: '+96\\0 000-0000', startsWith: '960', country: 'MV' },
  { mask: '+223 00-00-0000', startsWith: '223', country: 'ML' },
  { mask: '+356 0000-0000', startsWith: '356', country: 'MT' },
  { mask: '+692 000-0000', startsWith: '692', country: 'MH' },
  { mask: '+596 (000)00-00-00', startsWith: '596', country: 'MQ' },
  { mask: '+222 00-00-0000', startsWith: '222', country: 'MR' },
  { mask: '+23\\0 000-0000', startsWith: '230', country: 'MU' },
  { mask: '+262 00000-0000', startsWith: '262', country: 'YT' },
  { mask: '+52 00-00-0000', startsWith: '52', country: 'MX' },
  { mask: '+691 000-0000', startsWith: '691', country: 'FM' },
  { mask: '+373 0000-0000', startsWith: '373', country: 'MD' },
  { mask: '+377 00-000-000', startsWith: '377', country: 'MC' },
  { mask: '+976 00-00-0000', startsWith: '976', country: 'MN' },
  { mask: '+382 00-000-000', startsWith: '382', country: 'ME' },
  { mask: '+212 00-0000-000', startsWith: '212', country: 'MA' },
  { mask: '+258 00-000-000', startsWith: '258', country: 'MZ' },
  { mask: '+95 00-000-000', startsWith: '95', country: 'MM' },
  { mask: '+224 00-000-0000', startsWith: '224', country: 'NA' },
  { mask: '+674 000-0000', startsWith: '674', country: 'NR' },
  { mask: '+977 00-000-000', startsWith: '977', country: 'NP' },
  { mask: '+31 00-000-0000', startsWith: '31', country: 'NL' },
  { mask: '+599 000-0000', startsWith: '599', country: 'AN' },
  { mask: '+687 00-0000', startsWith: '687', country: 'NC' },
  { mask: '+24 0-000-000', startsWith: '24', country: 'NZ' },
  { mask: '+5\\05 0000-0000', startsWith: '505', country: 'NI' },
  { mask: '+227 00-00-0000', startsWith: '227', country: 'NE' },
  { mask: '+234 00-000-00', startsWith: '234', country: 'NG' },
  { mask: '+683 0000', startsWith: '683', country: 'NU' },
  { mask: '+672 300-000', startsWith: '672', country: 'NF' },
  { mask: '+389 00-000-000', startsWith: '389', country: 'MK' },
  { mask: '+47 000 00 000', startsWith: '47', country: 'NO' },
  { mask: '+968 00-000-000', startsWith: '968', country: 'OM' },
  { mask: '+92 000-0000000', startsWith: '92', country: 'PK' },
  { mask: '+68\\0 000-0000', startsWith: '680', country: 'PW' },
  { mask: '+97\\0 00-000-0000', startsWith: '970', country: 'PS' },
  { mask: '+5\\07 000-0000', startsWith: '507', country: 'PA' },
  { mask: '+675 (000)00-000', startsWith: '675', country: 'PG' },
  { mask: '+595 (000)000-000', startsWith: '595', country: 'PY' },
  { mask: '+51 (000)000-000', startsWith: '51', country: 'PE' },
  { mask: '+63 (000) 000 0000', startsWith: '63', country: 'PH' },
  { mask: '+87\\0 000-000-000', startsWith: '870', country: 'PN' },
  { mask: '+48 (000)000-000', startsWith: '48', country: 'PL' },
  { mask: '+351 00-000-0000', startsWith: '351', country: 'PT' },
  { mask: '+974 0000-0000', startsWith: '974', country: 'QA' },
  { mask: '+262 00000-0000', startsWith: '262', country: 'RE' },
  { mask: '+4\\0 00-000-0000', startsWith: '40', country: 'RO' },
  { mask: '+7 (000)000-00-00', startsWith: '7', country: 'RU' },
  { mask: '+25\\0 (000)000-000', startsWith: '250', country: 'RW' },
  { mask: '+59\\0 000-00-00-00', startsWith: '590', country: 'BL' },
  { mask: '+29\\0 0000', startsWith: '290', country: 'SH' },
  { mask: '+59\\0 (000)000-000', startsWith: '590', country: 'MF' },
  { mask: '+5\\08 00-0000', startsWith: '508', country: 'PM' },
  { mask: '+685 00-0000', startsWith: '685', country: 'WS' },
  { mask: '+378 0000-000000', startsWith: '378', country: 'SM' },
  { mask: '+239 00-00000', startsWith: '239', country: 'ST' },
  { mask: '+966 0-000-0000', startsWith: '966', country: 'SA' },
  { mask: '+221 00-000-0000', startsWith: '221', country: 'SN' },
  { mask: '+381 00-000-0000', startsWith: '381', country: 'RS' },
  { mask: '+248 0-000-000', startsWith: '248', country: 'SC' },
  { mask: '+232 00-000000', startsWith: '232', country: 'SL' },
  { mask: '+65 0000-0000', startsWith: '65', country: 'SG' },
  { mask: '+421 (000) 000-000', startsWith: '421', country: 'SK' },
  { mask: '+386 00-000-000', startsWith: '386', country: 'SI' },
  { mask: '+677 00000', startsWith: '677', country: 'SB' },
  { mask: '+252 0-000-000', startsWith: '252', country: 'SO' },
  { mask: '+27 00-000-0000', startsWith: '27', country: 'ZA' },
  { mask: '+5\\0\\0 00000', startsWith: '500', country: 'GS' },
  { mask: '+211 00-000-0000', startsWith: '211', country: 'SS' },
  { mask: '+34 (000)000-000', startsWith: '34', country: 'ES' },
  { mask: '+94 00-000-0000', startsWith: '94', country: 'LK' },
  { mask: '+249 00-000-0000', startsWith: '249', country: 'SD' },
  { mask: '+597 000-000', startsWith: '597', country: 'SR' },
  { mask: '+46 (000) 000-0000', startsWith: '46', country: 'SE' },
  { mask: '+41 00-000-0000', startsWith: '41', country: 'CH' },
  { mask: '+963 00-0000-000', startsWith: '963', country: 'SY' },
  { mask: '+886 000 000 000', startsWith: '886', country: 'TW' },
  { mask: '+992 00-000-0000', startsWith: '992', country: 'TJ' },
  { mask: '+255 00-000-0000', startsWith: '255', country: 'TZ' },
  { mask: '+66 000 000 000', startsWith: '66', country: 'TH' },
  { mask: '+67\\0 000-0000', startsWith: '670', country: 'TL' },
  { mask: '+228 00-000-000', startsWith: '228', country: 'TG' },
  { mask: '+69\\0 0000', startsWith: '690', country: 'TK' },
  { mask: '+676 00000', startsWith: '676', country: 'TO' },
  { mask: '+216 00-000-000', startsWith: '216', country: 'TN' },
  { mask: '+9\\0 (000) 000-0000', startsWith: '90', country: 'TR' },
  { mask: '+993 0-000-0000', startsWith: '993', country: 'TM' },
  { mask: '+688 20000', startsWith: '688', country: 'TV' },
  { mask: '+256 (000)000-000', startsWith: '256', country: 'UG' },
  { mask: '+38\\0 (00)000-00-00', startsWith: '380', country: 'UA' },
  { mask: '+971 0-000-0000', startsWith: '971', country: 'AE' },
  { mask: '+44 00-0000-0000', startsWith: '44', country: 'GB' },
  { mask: '+1 (000)000-0000', startsWith: '1', country: 'US' },
  { mask: '+598 0-000-00-00', startsWith: '598', country: 'UY' },
  { mask: '+998 00-000-0000', startsWith: '998', country: 'UZ' },
  { mask: '+678 00000', startsWith: '678', country: 'VU' },
  { mask: '+58 (000)000-0000', startsWith: '58', country: 'VE' },
  { mask: '+84 00-0000-000', startsWith: '84', country: 'VN' },
  { mask: '+681 00-0000', startsWith: '681', country: 'WF' },
  { mask: '+967 0-000-000', startsWith: '967', country: 'YE' },
  { mask: '+26\\0 00-000-0000', startsWith: '260', country: 'ZM' },
  { mask: '+263 0-000000', startsWith: '263', country: 'ZW' },
  {
    mask: '0000000000000',
    startsWith: '',
    country: 'unknown'
  }
];
